import { clsx } from 'clsx';
import { cva } from 'class-variance-authority';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Flex } from '@repo/ui/Flex';

import s from './InputMessage.module.css';

export const inputMessageVariantOptions = ['default', 'error'] as const;
export type InputMessageVariant = (typeof inputMessageVariantOptions)[number];

export type InputMessageProps = ComponentPropsWithRef<'div'> & {
  className?: string;
  children?: ReactNode;
  variant?: InputMessageVariant;
};

export const inputMessageVariants = cva(s.message, {
  variants: {
    variant: {
      default: s.defaultVariant,
      error: s.errorVariant,
    },
  },
});

export const InputMessage = (props: InputMessageProps) => {
  const { children, className, variant = 'default', ...attrs } = props;

  return (
    <Flex
      alignItems="flex-start"
      className={clsx(
        inputMessageVariants({
          variant,
        }),
        className,
      )}
      gap="g-8"
      padding="px-2"
      role={variant === 'error' ? 'status' : undefined}
      aria-live={variant === 'error' ? 'polite' : undefined}
      {...attrs}
    >
      {children}
    </Flex>
  );
};
